module.exports = __webpack_public_path__ + "img/yyzx.8b9f980f.png";